function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import Backdrop from './Backdrop';
import Box from './Box';
const OverlayContext = /*#__PURE__*/React.createContext();
const {
  Provider
} = OverlayContext;
const ESCAPE_KEY = 27;
const Overlay = /*#__PURE__*/React.memo(_ref => {
  let {
    onClose,
    children,
    ...props
  } = _ref;
  const containerRef = React.useRef(null);
  const backdropRef = React.useRef(null);
  const [inDom, setInDom] = useState(false);
  const value = React.useMemo(() => ({
    onClose
  }), [onClose]);
  const handleKeyDown = React.useCallback(event => {
    if (event.keyCode === ESCAPE_KEY) {
      event.preventDefault();
      onClose && onClose();
    }
  }, [onClose]);
  const handleBackdropClick = React.useCallback(event => event.target === backdropRef.current && onClose && onClose(), [onClose]);
  useEffect(() => {
    containerRef.current = document.createElement('div');
    document.body.appendChild(containerRef.current);
    setInDom(true);
    return () => {
      document.body.removeChild(containerRef.current);
    };
  }, []);
  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);
  const Overlay = /*#__PURE__*/React.createElement(Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(Backdrop, _extends({
    ref: backdropRef
  }, props, {
    onMouseDown: handleBackdropClick
  }), children));
  return inDom ? /*#__PURE__*/ReactDOM.createPortal(Overlay, containerRef.current) : null;
});
Overlay.propTypes = {
  ...Box.propTypes,
  /** Overlay is ready to be closed/removed */
  onClose: PropTypes.func
};
Overlay.defaultProps = {};
Overlay.displayName = 'Overlay';
export default Overlay;
export { OverlayContext };